export default __webpack_public_path__ + "static/media/us-ms.5f7b57a6.svg";